import React from 'react';
import * as R from 'ramda';
import { useIntl } from '@atlassian/jira-intl';
import { descend } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda/index.tsx';
import commonMessages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages.tsx';
import LegendContainer from '../legend-container/index.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

export default function IssueTypesLegend({ enrichedHierarchyLevels, filteredIssues }: Props) {
	const { formatMessage } = useIntl();

	const visibleIssueTypes = new Set(filteredIssues.map((issue) => issue.type));

	const sortedLevels = R.sort(descend(R.prop('level')), enrichedHierarchyLevels);
	const issueTypes = sortedLevels
		.flatMap((level) => level.issueTypes)
		.filter((issueType) => visibleIssueTypes.has(issueType.id));

	return (
		<LegendContainer title={formatMessage(commonMessages.issueType)}>
			{issueTypes.map((level, index) => (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div key={index} className={styles.legendItem}>
					<div
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className={styles.issueTypeIcon}
						style={{ backgroundImage: `url(${level.iconUrl})` }}
					/>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={styles.legendItemText}>{level.name}</div>
				</div>
			))}
		</LegendContainer>
	);
}
